/* eslint-disable import/prefer-default-export */
export const gl = {
  translation: {
    title: 'Validar copia autorizada electrónica',
    desc:'Introduce o CSV (Código Seguro de Verificación) e preme o botón Validar para comprobar a autenticidade e integridade da copia autorizada electrónica do documento notarial, así como para coñecer as notas posteriores de modificación xurídica e de coordinación con outros instrumentos públicos.',
    placeholderCSV:'Código CSV',
    validateButton: 'Validar',
    backButton:'Volver',
    okButton:'Aceptar',
    cancelButton:'Cancelar',
    closeButton:'Pechar',
    actionsButton:'Accións',
    downloadButton:'Descargar',
    head:{
      title: 'SEDE ELECTRÓNICA NOTARIAL',
    },
    footer:{
      legalNotice: 'Aviso Legal',
      privacyPolicy: 'Política de privacidade',
      accessibility: 'Accesibilidade',
      cookiesPolicy: 'Política de cookies',
      supportedBrowsers: 'Navegadores soportados',
    },
    modalsupportedbrowsers:{
      other: 'Podes acceder utilizando un PC, Mac, móbil ou tablet.',
    },
    actions: {
      helpButton:'Ver axuda',
      validateSignature:'Validar sinatura',
      download:'Descargar',
      downloadCombined: 'Descargar unidos'
    },
    modalAyuda:{
      title:'Axuda',
      guide:'Aquí podes descargar a guía relacionada con esta sección',
      section1: 'Comprobar a validez da sinatura mediante a Sede Electrónica Notarial',
      desc1: 'Para comprobar a validez da sinatura electrónica cualificada do notario no documento notarial, fai clic no botón <strong>Accións</strong> e selecciona <strong>Validar sinatura</strong>.',
      section2: 'Comprobar a validez da sinatura mediante Adobe Acrobat Reader',
      desc2: 'Para comprobar a validez da sinatura electrónica cualificada do notario no documento notarial, fai clic no botón <strong>Accións</strong> e selecciona <strong>Descargar</strong>. Despois, abre o documento con Adobe Acrobat Reader e fai clic na icona da pluma situada no menú lateral. <br /><br /> Na lista despregable poderás comprobar a validez da sinatura e analizar os seus detalles.',
      section3: 'Comprobar a validez da sinatura mediante VALIDe',
      desc3: 'Para comprobar a validez da sinatura electrónica cualificada do notario no documento notarial, fai clic no botón <strong>Accións</strong> e selecciona <strong>Descargar</strong>. Despois, utiliza a',
      linkText: 'plataforma pública VALIDe',
    },
    modalCopia:{
      title:'Copia autorizada electrónica',
    },
    modalErrorServicio:{
      desc: 'Non existe ningunha copia autorizada electrónica vinculada ao código CSV que introduciches. Revisa o código e inténtao de novo.',
      contactSupport: 'Se continúas tendo problemas, podes poñerte en contacto co servizo de soporte.',
    },
    modalAdvertenciaDescarga:{
      title:'Advertencia',
      desc:'<strong>As notas</strong> de modificación xurídica e de coordinación con outros instrumentos públicos <strong>emitidas despois da expedición da copia non estarán dispoñibles no documento que vas descargar.</strong> Só figuran no xustificante de expedición da copia.',
    },
    modalErrorGenerico:{
      desc:'Produciuse un problema. Inténtao de novo.',
    },
    modalErrorValidacion:{
      title:'Erro na validación da sinatura.',
      desc:'Non se puido validar a sinatura do documento. Inténtao de novo ou contacta co servizo de soporte.',
    },
    modalManuales:{
      name:'Nome',
    },
    modalValidacionFirma:{
      title:'Validar sinatura',
      firmaNotario:'SINATURA CUALIFICADA DO NOTARIO:',
      fechaFirma:'DATA DA SINATURA:',
      fechaValidacion:'DATA DA VALIDACIÓN:',
      estadoFirma:'ESTADO DA SINATURA:',
      validacionFirma:'Validación da sinatura electrónica do Consello Xeral do Notariado',
      validada:'Validada',
      noValidada:'Non válida',
      contenido:'Contido do documento',
      alterado:'alterado',
      noAlterado:'non alterado',
      certificadoFirmante:'Certificado do asinante',
      caducado:'caducado',
      noCaducado:'non caducado',
      revocado:'revogado',
      noRevocado:'non revogado',
      certificadoCa:'emitido por unha autoridade de certificación de confianza (CA)',
      noCertificadoCa:'non emitido por unha CA de confianza',
    },
  },
};
